import UserSection from "../../Services/User/UserLogin";
import { useEffect, useState } from "react";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import UserTopbar from "../UserTopbar";
import { useOutletContext } from "react-router-dom";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import EditNoteIcon from "@mui/icons-material/EditNote";
import Loader from "../utils/Loader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Typography,
  Box,
  Grid,
  Divider,
  Container,
  Button,
  Modal,
  TablePagination,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Skeleton
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddIcon from "@mui/icons-material/Add";
import { IoCreateSharp } from "react-icons/io5";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import Apiurl from "../../Helpers/apiUrl";
import { useDispatch, useSelector } from "react-redux";
import { fetchRegion, fetchState, fetchUserClient } from "../../redux/slices/clientSlice";
const ViewClient = () => {

  const dispatch = useDispatch();
  const [onEdit, setOnEdit] = useState(false);
  const [error, setError] = useState(null); // State to handle errors
  const [files, setFiles] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [modal, setModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { isSidebarOpen } = useOutletContext();
  const navigate = useNavigate();
  const { stateData, regionData, userClientsData, count, getStatus } = useSelector((state) => state.client);
  const counts = count || 0;

  const [formData, setFormData] = useState({
    client_name: "",
    id: "",
    site_add: "",
    afd: "",
    add_to: "",
    username: "",
    city: "",
    state: "",
    pin: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    dispatch(fetchRegion());
  }, []);

  useEffect(() => {
    dispatch(fetchUserClient({
      search: searchQuery,
      page: page,
      rowsPerPage: rowsPerPage,
    }));
  }, [searchQuery, page, rowsPerPage]);


  useEffect(() => {
    dispatch(fetchState({ id: regionData?.find(r => r.name === formData.city)?.id }));
  }, [formData.city]);

  // Validation state
  const [errors, setErrors] = useState({});

  // Form validation
  const validateForm = () => {
    let errors = {};

    if (!formData.client_name) {
      errors.client_name = "Client Name is required";
    } else if (!/^[a-zA-Z0-9\s]+$/.test(formData.client_name)) {
      errors.client_name = "Special characters are not allowed in Client Name";
    }

    if (!formData.site_add) {
      errors.site_add = "Billing Address is required";
    }

    // if (!formData.afd) {
    //   errors.afd = "Architect Firm Details are required";
    // }

    if (!formData.add_to) {
      errors.add_to = "Site Address is required";
    }
    // if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //   errors.email = "Email Address is invalid";
    // }
    if (!/^\d{10}$/.test(formData.phone)) {
      errors.phone = "Phone Number must be exactly 10 digits";
    }

    if (!formData.city) {
      errors.city = "City is required";
    }

    if (!formData.state) {
      errors.state = "State is required";
    }

    // if (formData.pin && !/^\d{6}$/.test(formData.pin)) {
    //   errors.pin = "Pin Code must be 6 digits";
    // }

    return errors;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form
    const validationErrors = validateForm();

    // If there are validation errors, update the error state and return
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Proceed with the form submission if no errors
    try {
      const response = onEdit
        ? await UserSection.updateClient(formData)
        : await UserSection.addClient(formData);

      if (response.status) {
        Swal.fire({
          icon: "success",
          title: onEdit ? "Client Updated" : "Client Added",
          text: `Client ${onEdit ? "updated" : "added"} successfully`,
          timer: 3000,
        });

        setFormData({
          id: "",
          client_name: "",
          site_add: "",
          afd: "",
          add_to: "",
          username: "",
          state: "",
          city: "",
          pin: "",
          email: "",
          phone: "",
        });
        setModal(false);

        dispatch(fetchUserClient({
          search: '',
          page: page,
          rowsPerPage: rowsPerPage,
        }));
      }
    } catch (error) {
      handleApiError(
        error,
        `Failed to ${onEdit ? "update" : "add"} client. Please try again later.`
      );
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setErrors({
      ...errors,
      [name]: "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const addbulkclient = (event) => {
    const file = event.target.files[0];
    setFiles(file);

    const reader = new FileReader();
    let allSheetData = [];

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        const rowsData = jsonData.slice(1).map((row) => {
          return {
            // id: row[0],
            client_name: row[0],
            site_add: row[1],
            add_to: row[2],
            city: row[3],
            state: row[4],
            pin: row[5],
            afd: row[6],
            email: row[7],
            phone: row[8],
          };
        });

        allSheetData.push(...rowsData);
      });

      const invalidRow = allSheetData.find(row => /[^a-zA-Z0-9\s]/.test(row.client_name));

      if (invalidRow) {
        Swal.fire({
          icon: "error",
          title: "Invalid Client Name",
          text: `Special characters are not allowed: "${invalidRow.client_name}"`,
        });
        return;
      }

      importcsvfile1(allSheetData);
      setExcelData(allSheetData);
      setError("");
    };

    reader.readAsArrayBuffer(file);
  };

  const importcsvfile1 = async (data) => {
    try {
      if (data) {
        const importData = await UserSection.addClient_bulk(data);
        if (importData.status === true) {
          Swal.fire({
            icon: "success",
            title: "Client",
            text: "Client added successfully",
            timer: 3000, // Automatically close after 3 seconds
          });
        }
        setModal(false);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const downloadcsv = async (e) => {
    try {
      e.preventDefault();
      const url = "https://quotationsapis.groheapp.in/public/excel/client.xlsx";
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "sku_data.xlsx";
      anchor.click();
    } catch (error) {
      console.log(error);
    }
  };

  if (error) {
    return <div className="text-center text-red-500 py-6">{error}</div>;
  }

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };


  // const createQuatation = (id) => {
  //   navigate(`/user/projects`);
  //   localStorage.setItem("client_id", id);
  // };

  const createQuatation = (row) => {
    navigate(`/user/create-quote/${row.id}/${encodeURIComponent(row.client_name)}`);
  };



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const editClient = (client) => {
    setOnEdit(true);
    setFormData({
      id: client.id,
      client_name: client.client_name,
      site_add: client.site_add,
      city: client.city,
      state: client.state,
      pin: client.pin,
      add_to: client.add_to,
      afd: client.afd,
      email: client.email,
      phone: client.phone,

    });
    setModal(true);
  };

  // Download current (filtered and paginated) data as Excel
  const downloadCurrentExcel = () => {
    const dataToExport = userClientsData?.map((client, idx) => ({
      'Sr.No': idx + 1 + page * rowsPerPage,
      'Client ID': client.id,
      'Client Name': client.client_name,
      'Billing Address': client.site_add,
      'City': client.city,
      'State': client.state,
      'Pin Code': client.pin,
      'Site Address': client.add_to,
      'Architect Firm': client.afd,
      'Email': client.email,
      'Phone': client.phone,
      'Created At': client.updated_at ? new Date(client.updated_at).toLocaleDateString('en-GB') : '',
    }));
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Clients');
    XLSX.writeFile(wb, 'clients.xlsx');
  };

  return (
    <>
      <UserTopbar heading="Add / View Client" sidebar={isSidebarOpen} />
      {/* Loader removed, using Skeleton below */}
      {modal && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(15, 23, 42, 0.4)",
            backdropFilter: "blur(8px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Container
            maxWidth="md"
            className="bg-white/95 backdrop-blur-xl border border-white/50 shadow-2xl rounded-3xl"
            sx={{
              position: "relative",
              p: 4,
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: "900", color: "#1e293b", letterSpacing: "-0.02em" }}
              >
                Add New Client
              </Typography>
              <Box display="flex" gap={2}>
                <Button
                  variant="contained"
                  startIcon={<DownloadIcon />}
                  onClick={downloadcsv}
                  sx={{
                    bgcolor: "#ff7b00",
                    color: "white",
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    borderRadius: "9999px",
                    boxShadow: "0 2px 10px 0 rgba(255, 123, 0, 0.2)",
                    "&:hover": { bgcolor: "#e06a00" }
                  }}
                >
                  Download Format
                </Button>
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<UploadFileIcon />}
                  sx={{
                    borderColor: "#ff7b00",
                    color: "#ff7b00",
                    fontWeight: "bold",
                    borderRadius: "9999px",
                    textTransform: "capitalize",
                    "&:hover": {
                      bgcolor: "rgba(255, 123, 0, 0.05)",
                      borderColor: "#e06a00",
                    },
                  }}
                >
                  Upload File
                  <input type="file" hidden onChange={addbulkclient} />
                </Button>
              </Box>
            </Box>

            <Divider sx={{ mb: 4 }} />

            <Box component="form" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {[
                  {
                    label: "Client Name *",
                    name: "client_name",
                    error: errors.client_name,
                  },
                  {
                    label: "Billing Address *",
                    name: "site_add",
                    error: errors.site_add,
                  },
                  {
                    label: "Region *",
                    name: "city",
                    error: errors.city,
                    type: "select",
                    options: regionData || [],
                  },
                  {
                    label: "State *",
                    name: "state",
                    error: errors.state,
                    type: "select",
                    options: stateData || [],
                  },
                  { label: "Pin Code", name: "pin", error: errors.pin },
                  {
                    label: "Architect Firm Details ",
                    name: "afd",
                    error: errors.afd,
                  },
                  { label: "Email", name: "email", error: errors.email },
                  { label: "Phone *", name: "phone", error: errors.phone },
                  {
                    label: "Site Address *",
                    name: "add_to",
                    error: errors.add_to,
                  },
                ].map(({ label, name, error, type, options }, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    {type === "select" ? (
                      <FormControl fullWidth>
                        <InputLabel>{label}</InputLabel>
                        <Select
                          label={label}
                          name={name}
                          value={formData[name]}
                          onChange={handleChange}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              bgcolor: "rgba(248, 250, 252, 0.8)",
                              borderRadius: "12px",
                              transition: "all 0.2s",
                              "& fieldset": {
                                borderColor: "rgba(203, 213, 225, 0.5)",
                              },
                              "&:hover fieldset": {
                                borderColor: "#ff7b00",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#ff7b00",
                                borderWidth: 2,
                              },
                            },
                            "& .MuiInputLabel-root": {
                              color: "text.secondary",
                              fontSize: "0.95rem",
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: "#ff7b00",
                            },
                          }}
                        >
                          <MenuItem value="">
                            <em>Select {label}</em>
                          </MenuItem>
                          {options?.map((option) => (
                            <MenuItem key={option.id} value={option.name}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                        {error && (
                          <FormHelperText sx={{ color: "error.main" }}>
                            {error}
                          </FormHelperText>
                        )}
                      </FormControl>
                    ) : (
                      <TextField
                        label={label}
                        fullWidth
                        name={name}
                        value={formData[name]}
                        onChange={handleChange}
                        error={!!error}
                        helperText={error}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            bgcolor: "rgba(248, 250, 252, 0.8)",
                            borderRadius: "12px",
                            transition: "all 0.2s",
                            "& fieldset": {
                              borderColor: "rgba(203, 213, 225, 0.5)",
                            },
                            "&:hover fieldset": {
                              borderColor: "#ff7b00",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#ff7b00",
                              borderWidth: 2,
                            },
                          },
                          "& .MuiInputLabel-root": {
                            color: "text.secondary",
                            fontSize: "0.95rem",
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#ff7b00",
                          },
                          "& .MuiFormHelperText-root": {
                            color: "error.main",
                          },
                        }}
                      />
                    )}
                  </Grid>
                ))}
              </Grid>

              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ mt: 4, gap: 4 }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    px: 6,
                    py: 1.5,
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    bgcolor: "#ff7b00",
                    color: "white",
                    borderRadius: "9999px",
                    boxShadow: "0 4px 14px 0 rgba(255, 123, 0, 0.39)",
                    "&:hover": {
                      bgcolor: "#e06a00",
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 20px 0 rgba(255, 123, 0, 0.39)",
                    },
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  {onEdit ? "Update" : "Add Client"}
                </Button>
                <Button
                  onClick={() => {
                    setModal(false);
                    setOnEdit(false);
                    setFormData({
                      client_name: "",
                      id: "",
                      site_add: "",
                      afd: "",
                      add_to: "",
                      username: "",
                      city: "",
                      state: "",
                      pin: "",
                      email: "",
                      phone: "",
                    });
                    setErrors({});
                  }}
                  variant="outlined"
                  sx={{
                    px: 6,
                    py: 1.5,
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    color: "#64748b",
                    borderColor: "#cbd5e1",
                    borderRadius: "9999px",
                    "&:hover": {
                      bgcolor: "#f1f5f9",
                      borderColor: "#94a3b8",
                      color: "#475569"
                    },
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Container>
        </Box>
      )}
      {/* Client Details Section (Card-like table) */}
      <div className="flex-1 bg-white/60 backdrop-blur-md shadow-lg rounded-2xl border border-white overflow-hidden mx-4 mb-4">
        <Box>
          {/* Header Container with Search and Title */}
          <Box
            className="border-b border-white/50"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 3,
            }}
          >
            {/* <Typography variant="h5" sx={{ fontWeight: "bold", color: "#fff" }}>
              Client Details
            </Typography> */}
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="Search clients..."
                className="py-2.5 pl-4 pr-10 w-[24rem] bg-white/50 border border-white/60 rounded-full text-slate-700 shadow-inner focus:outline-none focus:ring-2 focus:ring-blue-400/50 transition duration-300 placeholder-slate-400 backdrop-blur-sm"
                required
              />
              <span className="absolute inset-y-0 right-0 flex items-center pr-4">
                <FaSearch className="text-slate-400" />
              </span>
            </div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button
                onClick={downloadCurrentExcel}
                className="flex items-center gap-2 px-5 py-2.5 bg-white/70 hover:bg-white/90 text-slate-700 font-semibold rounded-full shadow-sm hover:shadow-md border border-white/50 transition-all duration-300"
              >
                <DownloadIcon fontSize="small" /> Export
              </button>
              <button
                onClick={() => setModal(true)}
                className="flex items-center gap-2 px-6 py-2.5 bg-[#ff7b00] hover:bg-[#e06a00] text-white font-bold rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5"
              >
                <PersonAddOutlinedIcon fontSize="small" /> Add Client
              </button>
            </div>
          </Box>

          {/* Table */}
          <TableContainer sx={{ maxHeight: 'calc(100vh - 250px)' }}>
            <Table aria-label="clients table" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Sr.No
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Client ID
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Client Name
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Transferred From
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Billing Address
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Region
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    State
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Pin Code
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Site Address
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Architect Firm
                  </TableCell>

                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Phone
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Created At
                  </TableCell>
                  <TableCell
                    className="bg-white/40"
                    sx={{
                      color: "#334155",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              {getStatus === 'pending' ? (

                <TableBody sx={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}>
                  {Array.from(new Array(rowsPerPage)).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      <TableCell><Skeleton variant="text" width={30} /></TableCell>
                      <TableCell><Skeleton variant="text" width={60} /></TableCell>
                      <TableCell><Skeleton variant="text" width={120} /></TableCell>
                      <TableCell><Skeleton variant="text" width={100} /></TableCell>
                      <TableCell><Skeleton variant="text" width={150} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={80} /></TableCell>
                      <TableCell><Skeleton variant="text" width={60} /></TableCell>
                      <TableCell><Skeleton variant="text" width={150} /></TableCell>
                      <TableCell><Skeleton variant="text" width={100} /></TableCell>
                      <TableCell><Skeleton variant="text" width={120} /></TableCell>
                      <TableCell><Skeleton variant="text" width={90} /></TableCell>
                      <TableCell><Skeleton variant="text" width={90} /></TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Skeleton variant="circular" width={28} height={28} />
                          <Skeleton variant="circular" width={28} height={28} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              ) : (<TableBody
                sx={{
                  backgroundColor: "transparent",
                }}
              >

                {userClientsData?.map((client, index) => (
                  <TableRow
                    key={client.id}
                    hover
                    sx={{ "&:hover": { bgcolor: "rgba(255, 255, 255, 0.4)" } }}
                  >
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{client.id}</TableCell>
                    <TableCell>
                      <div className="flex items-center gap-2">
                        <span>{client.client_name}</span>
                        {client.transferred_user_name && (
                          <span className="relative flex h-5 w-5">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 "></span>
                            <span className="relative inline-flex items-center justify-center rounded-full h-5 w-5 bg-orange-600 text-white text-[10px] font-bold">
                              T
                            </span>
                          </span>
                        )}
                      </div>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" sx={{ color: "#757574" }}>
                        {client.transferred_user_name ? client.transferred_user_name : "Not Transferred"}
                      </Typography>
                    </TableCell>
                    <TableCell>{client.site_add}</TableCell>
                    <TableCell>{client.city}</TableCell>
                    <TableCell>{client.state}</TableCell>
                    <TableCell>{client.pin}</TableCell>
                    <TableCell>{client.add_to}</TableCell>
                    <TableCell>{client.afd}</TableCell>
                    <TableCell>{client.email}</TableCell>
                    <TableCell>{client.phone}</TableCell>
                    <TableCell>{client ? new Date(client.updated_at).toLocaleDateString("en-GB") : ""}</TableCell>
                    <TableCell>
                      <span className="flex gap-5 text-white">
                        <button
                          onClick={(e) => createQuatation(client)}
                          sx={{ color: "primary" }}
                        >
                          {" "}
                          <Tooltip title={"Create Quote"} arrow>
                            <EditNoteIcon
                              className="bg-green-600 hover:bg-green-300 hover:text-green-600 p-1 rounded-full scale-125"
                              style={{
                                fontSize: "30px",
                                // color: "blue",
                              }}
                            />
                          </Tooltip>
                        </button>
                        <button
                          onClick={(e) => editClient(client)}
                          sx={{ color: "primary" }}
                        >
                          {" "}
                          <Tooltip title={"Edit CLient"} arrow>
                            <RuleOutlinedIcon
                              className="bg-blue-600 hover:bg-blue-300 hover:text-blue-600 p-1 rounded-full scale-110"
                              style={{
                                fontSize: "30px",
                                // color: "blue",
                              }}
                            />
                          </Tooltip>
                        </button>
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
            rowsPerPageOptions={[10, 50, 100, 500, counts]}
            component="div"
            count={counts}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </div>
    </>
  );
};

export default ViewClient;
